import { memo, useEffect } from 'react';
import { BzHeading } from '../../../components';
import { Row, Col, Container } from 'react-bootstrap';
import { setArrRecentlySearchMFScrips } from '../../../redux/actions/globalSearch';
import { useDispatch } from 'react-redux';
import { getDecryptLocalStorage } from '../../../utils/global_functions';

// {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */ }
const RecentMutualFundsSearch = ({ scrips, isExpand, handleRecentSearch, onChangeGlobalSearch }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const searchArray = getDecryptLocalStorage('RECENTLY_SEARCHED_MF');
        if (searchArray) {
            const parsedArray = JSON.parse(searchArray);
            dispatch(setArrRecentlySearchMFScrips([...parsedArray]));
        } else { }
    }, [dispatch]);

    return (
        <>
            {
                scrips?.length > 0 &&
                <Container fluid className='p-0'>
                    <BzHeading className='font-medium font-size3 color-subtext text-uppercase'>RECENTLY SEARCHED</BzHeading>
                    {
                        scrips?.map((eachScrip, i) => (
                            <Row className='g-0 px-3 py-2 justify-content-around' key={i}>
                                <Col onClick={() => onChangeGlobalSearch({ target: { value: eachScrip.scheme_name } })}>
                                    <div class='icon-20 icon-search icon-dark'></div>
                                    <div className='d-inline-block'>
                                        <BzHeading className='font-medium font-size3 color-text text-uppercase float-start'>{eachScrip.scheme_name}</BzHeading>
                                    </div>
                                    <div className='clear'></div>
                                </Col>
                            </Row>
                        ))
                    }
                </Container>
            }
        </>
    );
};

export default memo(RecentMutualFundsSearch);
// {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */ }
